import { Injectable } from '@angular/core';

import { orgaosStorage } from "./data.service";
import { areasStorage } from "../../areas/shared/data.service";
import { AreaNavigationService } from "../../areas/shared/area-navigation.service";
import { AreaService } from "../../areas/shared/area.service";
import { AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import { frotasStorage } from "../../../bens/frotas/shared/data.service";
import { FrotasService } from "../../../bens/frotas/shared/frota.service";
import { FrotaNavigationService } from "../../../bens/frotas/shared/frota-navigation.service";

@Injectable()
export class OrgaoService {

  constructor(
    private _areaNavigationService: AreaNavigationService,
    private _areaService: AreaService,    
    private _frotaNavigationService: FrotaNavigationService,
    private _frotaService: FrotasService,

    private _autocompleteService: AutoCompleteService
  ) { }

  //session
  setSessionStorage(item: any) {
    var object: string = JSON.stringify(item);
    sessionStorage.setItem(orgaosStorage + '-new', object);
  }

  getSessionStorage() {
    var item: string = sessionStorage.getItem(orgaosStorage + "-new");
    return JSON.parse(item);
  }

  clearSessionStorage() {
    sessionStorage.removeItem(orgaosStorage + "-new");
  }

  returnToOtherForm(otherForm: string, Response: any) {
    if(Response) {
      var otherFormObject: any;

      if (otherForm === areasStorage) {
        otherFormObject = this._areaService.getSessionStorage();
        otherFormObject.orgao = Response;
        this._areaService.setSessionStorage(otherFormObject);
      } else if (otherForm === frotasStorage) {
        otherFormObject = this._frotaService.getSessionStorage();
        otherFormObject.orgao = Response;
        this._frotaService.setSessionStorage(otherFormObject);
      }
    }

    this._autocompleteService.clearSessionStorage(orgaosStorage);

    if (otherForm === areasStorage) {
      otherFormObject = this._areaService.getSessionStorage();
      if (otherFormObject.id) {
        this._areaNavigationService.goToEdit(otherFormObject.id);
      } else {
        this._areaNavigationService.goToNew();
      }
    } else if (otherForm === frotasStorage) {
      otherFormObject = this._frotaService.getSessionStorage();
      var frotasRoute = otherFormObject.thisRoute;
      if (otherFormObject.id) {
        this._frotaNavigationService.goToEdit(otherFormObject.id, frotasRoute);
      } else {
        this._frotaNavigationService.goToNew(frotasRoute);
      }
    }
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/orgaos/shared/orgao.service.ts
 **/